// import Item from "./Item";
import Slider from "./Slider";

export default Slider;
